<template>
  <div class="aiHomePage aiPageBg homeContent">
    <!-- <div class="homeTitle">
        <div class="text">Smart Sketcher AI</div>
        <div class="iconBox">
          <img class="icon" src="../../assets/img/icon/icon_add.png" />
        </div>
      </div> -->
    <navbar :nav="nav"></navbar>
    <div class="isContent">
      <div class="homeLevelBox">
        <div class="title">{{ level.packageName?level.packageName:'-' }}</div>
        <!-- {{ level.type }}套餐类型:0每天，1自定义，2无限,3基础套餐
          会员权益显示的（每日xx枚生成可能），
          当套餐类型是自定义或者无限时要更改文字，自定义时是「xx日以内xx枚生成可能」，
          无限套餐时没有日数限制（xx枚生成可能） -->
        <div class="levelBox">
          <div class="left">
            <div class="text">
              <div v-if="level.type == 0 || level.type == 3">
                毎日{{ level.generateNumber }}枚まで
              </div>
              <div v-if="level.type == 1" class="textOverflow">
                {{ level.toDay?level.toDay:'1' }}日以内{{ level.generateNumber }}枚生成可能
              </div>
              <div v-if="level.type == 2">
                {{ level.generateNumber }}枚生成可能
              </div>
              <div>
                {{ level.alreadyGenerateNumber }}/{{ level.generateNumber }}
              </div>
            </div>
            <van-slider
              v-model="level.value"
              bar-height="8px"
              active-color="#0084FF"
              inactive-color="#E9EAEC"
            >
              <template #button>
                <div class="custom-button" style="display: none;"></div>
              </template>
            </van-slider>
          </div>
          <van-button type="info" class="buttonBlue" @click="gotoPackage()"
            >無制限に</van-button
          >
        </div>
      </div>
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item, index) in bannerItem" :key="index">
          <img
            class="img"
            :src="item.imageUrl"
            @dragstart.prevent
            style="width:100%;"
            @click="jumpUrl(item.jumpUrl)"
          />
        </van-swipe-item>
      </van-swipe>

      <div class="hualang">ギャラリー</div>

      <div class="noContent" v-if="isContent">
        <div>生成した画像はここに表示します。</div>
        <div>chatで画像生成をスタートしましょう！</div>
      </div>
      <div id="content" v-if="!isContent">
        <div class="imgItem" v-for="(item, index) in imgData" :key="index">
          <div
            class="date"
            v-if="item.childrenList && item.childrenList.length > 0"
          >
            {{ item.time }}
          </div>
          <div
            class="itemsBox"
            v-if="item.childrenList && item.childrenList.length > 0"
          >
            <div
              class="items"
              v-for="(i, k) in item.childrenList"
              :key="k"
              @click="
                $router.push({ path: `/generateResult`, query: { id: i.id } })
              "
            >
              <img v-if="i.firstPicture" class="img" :src="i.firstPicture" />
              <img
                v-if="i.firstPicture == '' && i.secondPicture != ''"
                class="img"
                :src="i.secondPicture"
              />
              <img
                v-if="
                  i.firstPicture == '' &&
                    i.secondPicture == '' &&
                    i.thirdPicture != ''
                "
                class="img"
                :src="i.thirdPicture"
              />
              <img
                v-if="
                  i.firstPicture == '' &&
                    i.secondPicture == '' &&
                    i.thirdPicture == '' &&
                    i.fourthPicture != ''
                "
                class="img"
                :src="i.fourthPicture"
              />
              <div class="operate">
                <img
                  class="icon"
                  src="../../assets/img/icon/icon_del.png"
                  @click.stop="delImg(i)"
                />
                <img
                  class="icon"
                  @click="
                    $router.push({
                      path: `/generateResult`,
                      query: { id: i.id }
                    })
                  "
                  src="../../assets/img/icon/icon_arrow.png"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <van-loading
        type="spinner"
        color="#2b99ff"
        v-if="loading"
        style="margin: 0 auto;width: 32px;"
      />
    </div>
    <van-popup v-model="goDelImgPopup">
      <div class="content">
        <div>この中に複数の写真が含まれています。すべて削除しますか？</div>
        <!-- <div>全部削除しますか?</div> -->
      </div>
      <div class="buttonItem">
        <div class="button cancel" @click="goDelImgPopup = false">
          キャンセル
        </div>
        <div class="button del" @click="saveDelImg()">削除</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import { Toast } from "vant";

Vue.use(Toast);
import "vant/lib/index.css";
import navbar from "../../components/navbar/index.vue";
import {
  memberPackage,
  bannerList,
  pictureList,
  pictureDelete
} from "@/http/home";
export default {
  components: {
    navbar
  },
  data() {
    return {
      nav: {
        back: false,
        title: "Smart Sketcher AI",
        chat: true
      },
      bannerItem: [],
      level: {
        value: 0,
        alreadyGenerateNumber: 0,
        generateNumber: 0
      },
      imgData: [],
      delData: {},
      goDelImgPopup: false,
      isContent: false,
      pageNo: 1,
      finished: false,
      loading: false,
      total: 0,
      backgroundColor: ""
    };
  },
  mounted() {
    localStorage.removeItem("message");
    localStorage.removeItem("messageType");
    this.getBanner();
    this.getPicList();
  },
  methods: {
    onChange(index) {
      console.log(index);
    },
    getBanner() {
      memberPackage().then(res => {
        let { data, code } = res.data;
        if (code == 200) {
          if (data) {
            this.level = data;
            // this.level.alreadyGenerateNumber  = 3
            this.level.value =
              (this.level.alreadyGenerateNumber / this.level.generateNumber) *
              100;
          }
        }
      });
      bannerList().then(res => {
        let { data, code } = res.data;
        if (code == 200) {
          this.bannerItem = data;
        }
      });
    },
    getPicList() {
      this.loading = true;
      pictureList({ pageNo: this.pageNo, pageSize: "10" }).then(res => {
        let { data, code } = res.data;
        if (code == 200) {
          this.loading = false;
          this.total = data.total;
          if (this.pageNo > 1) {
            this.imgData = this.imgData.concat(data.list);
          } else {
            this.imgData = data.list;
          }
          this.isContent = data.list.every(item => {
            return item.childrenList.length === 0;
          });
        }
      });
    },
    delImg(i) {
      this.delData = i;
      this.goDelImgPopup = true;
    },
    saveDelImg() {
      //确定删除
      let id = this.delData.id;
      pictureDelete(id).then(res => {
        let { data, code } = res.data;
        if (code == 200) {
          this.goDelImgPopup = false;
          this.loading = true;
          this.pageNo = 1;
          this.imgData = [];
          this.getPicList();
          Toast({
            type: "success",
            // duration: 0,
            message: "削除しました"
          });
        }
      });
    },
    jumpUrl(url) {
      window.open(url, "_blank");
    },
    gotoPackage() {
      this.$router.push({ path: `/unlockPackage` });
    }
  }
};
</script>

<style>
.testImg1 {
  background: url("../../assets/img/img1.png") no-repeat top center;
}
.testImg2 {
  background: url("../../assets/img/img2.png") no-repeat top center;
}
.aiHomePage.aiPageBg {
  /* width: 100%; */
  /* height: calc(100% - 30px); */
  height: 100%;
}
.homeContent {
  /* width: 100%;
  height: 100%; */
  /* width: calc(100% - 30px); */
  /* height: calc(100% - 140px); */
  /* box-sizing: border-box; */
  /* overflow: hidden; */
  /* padding: 0 15px; */
  /* overflow-y: scroll; */
}
.homeContent .isContent {
  height: calc(100% - 105px);
  height: -webkit-calc(100% - 105px);
  width: 100%;
  /* padding-top: 60px; */
  overflow-y: scroll;
  overflow-x: hidden;
}
.aiHomePage .homeTitle {
  display: flex;
  justify-content: space-between;
}
.aiHomePage .homeTitle .text {
  font-family: ThinFont, RegularFont;
  font-size: 18px;
  font-weight: normal;
  line-height: 40px;
  letter-spacing: 0px;

  color: #ffffff;
}
.aiHomePage .homeTitle .iconBox {
  width: 40px;
  height: 40px;
  border-radius: 20px;
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.aiHomePage .homeTitle .icon {
  width: 18px;
  height: 18px;
  display: block;
}
.homeLevelBox {
  /* width: 100%; */
  width: calc(100% - 30px);
  height: 93px;
  background: url("../../assets/img/home_level_bg.png") no-repeat top center;
  background-size: cover;
  margin: 6px auto 10px auto;
}
.homeLevelBox .title {
  font-family: SemiBoldFont;
  font-size: 18px;
  font-weight: normal;
  line-height: 16px;
  letter-spacing: 0.9px;
  color: #232036;
  padding: 9px 0 15px 14px;
}
.homeLevelBox .levelBox {
  padding: 0 14px;
}
.homeLevelBox .levelBox,
.homeLevelBox .levelBox .text {
  display: flex;
  justify-content: space-between;
}

.homeLevelBox .levelBox .left {
  width: 200px;
}
.homeLevelBox .levelBox .text {
  font-family: RegularFont;
  font-size: 14px;
  font-weight: normal;
  line-height: 17px;
  letter-spacing: 0.7px;
  color: #5e5b70;
  margin-top: 1px;
  margin-bottom: 11px;
}
#app .homeLevelBox .levelBox .buttonBlue {
  height: 40px;
  line-height: 40px;
  border-radius: 8px;
  width: 85.75px;
  letter-spacing: 2.1px;
  font-size: 14px;
}
.homeLevelBox .levelBox .textOverflow {
  width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 18px;
}
/* banner */
.my-swipe {
  /* width: 100%; */
  width: calc(100% - 30px);
  height: 194.06px;
  border-radius: 8px;
  overflow: hidden;
  margin: 0 auto;
}
.my-swipe .van-swipe-item {
  width: 100%;
  color: #fff;
  font-size: 20px;
  height: 194.06px;
  border-radius: 8px;
  text-align: center;
  background-color: #66b5ff;
}
.my-swipe .van-swipe-item .img {
  width: 100%;
  height: 100%;
  object-fit:cover;
}
.my-swipe .van-swipe__indicator {
  width: 8px;
  height: 6px;
  border-radius: 3px;
  background: rgb(255, 255, 255, 0.3);
}
.my-swipe .van-swipe__indicator.van-swipe__indicator--active {
  width: 16px;
  height: 6px;
  border-radius: 3px;
  background: #ffffff;
}
.aiHomePage .hualang {
  width: calc(100% - 30px);
  font-family: MediumFont;
  font-size: 18px;
  font-weight: normal;
  line-height: 22px;
  letter-spacing: 0px;
  margin-top: 20px;
  margin-bottom: 14px;
  margin-left: auto;
  margin-right: auto;
  color: #232036;
}
.aiHomePage #content {
  width: calc(100% - 30px);
  /* width: 100%; */
  margin: 0 auto;
  max-height: calc(100% - 350px);
  /* overflow-y: scroll; */
  padding: 0 15px;
}
/* 缺省css */
.noContent {
  /* position: fixed;
  left: 8%;
  top: 40%;
  width: 85%; */
  height: 70px;
  background: url("../../assets/img/home_noConetnt_bg.png") no-repeat top center;
  background-size: 141px 180px;
  font-family: RegularFont;
  font-size: 16px;
  font-weight: normal;
  line-height: 22px;
  text-align: center;
  /* 11.Black/Alpha 0.9-填充 */
  color: rgba(0, 0, 0, 0.9);
  margin: 0 auto;
  padding-top: 108px;
  margin-top: 30px;
}

@media screen and (min-width: 1439px) {
  .homeContent {
    /* height: calc(100% - 40px); */
    /* no*/
    /* padding-bottom: 10px; */
    /* no*/
  }
  .homeContent .isContent {
    height: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
  }
  .homeContent .my-swipe {
    width: calc(100% - 30px); /* no*/
  }
  .homeContent .my-swipe,
  .homeContent .my-swipe .van-swipe-item {
    height: 262px; /* no*/
  }
  .homeContent .noContent {
    font-size: 16px !important; /* no*/
    margin-top: 30px; /* no*/
  }

  .homeLevelBox {
    width: calc(100% - 30px); /* no*/
    height: 123px; /* no*/
    margin: 6px auto 10px auto; /* no*/
  }
  .homeLevelBox .levelBox .left {
    width: 65% !important; /* no*/
  }
  #app .homeLevelBox .levelBox .buttonBlue {
    width: 24% !important; /* no*/
  }
  #app .homeLevelBox .levelBox .buttonBlue,
  .homeLevelBox .levelBox .text {
    font-size: 16px !important; /* no*/
  }
  .homeLevelBox .title {
    font-size: 18px !important; /* no*/
    line-height: 16px; /* no*/
    letter-spacing: 0.9px; /* no*/
    padding: 19px 0 15px 14px; /* no*/
  }
  .homeLevelBox .levelBox .textOverflow {
    height: 22px; /* no*/
  }
  .aiHomePage .hualang {
    width: calc(100% - 30px); /* no*/
    font-size: 18px; /* no*/
    line-height: 22px; /* no*/
    margin-top: 20px; /* no*/
    margin-bottom: 14px; /* no*/
  }

  .aiHomePage #content {
    width: calc(100% - 30px); /* no*/
    max-height: calc(100% - 250px); /* no*/
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue